import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import ErrorFallback from './views/pages/ErrorFallback';

import './utils/i18n';
import './utils/appInitialize';

import 'react-notification-alert/dist/animate.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
// import '@fullcalendar/common/main.min.css';
// import '@fullcalendar/daygrid/main.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
// import 'select2/dist/css/select2.min.css';
// import 'quill/dist/quill.core.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/vendor/nucleo/css/nucleo.css';
import './assets/scss/argon-dashboard-pro-react.scss';

import App from './App';
import { StoreProvider } from './Store';
import { getLanguage } from './utils/helpers';
import reactQueryApiClient from './utils/api/react-query-api-client';

const language = getLanguage();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: reactQueryApiClient(`${process.env.REACT_APP_API_ENDPOINT}/v3/`),
      // global default to 60 seconds and 10 minutes
      staleTime: 1000 * 60,
      cacheTime: 1000 * 60 * 10,
      retry: 2
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Suspense
    fallback={
      <div className="page-center">
        <div className="reverse-spinner" />
        <h2 className="mt-3">Golfamore</h2>
      </div>
    }
  >
    {/* Sentry first after language loaded otherwise ErrorFallback don't work */}
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog lang={language}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <StoreProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </StoreProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </Suspense>
);
